module.exports = __webpack_public_path__ + "img/cube.expo.a01e76fe.webp";